(function(scope){
 function key(row){
  const title=(row.title||'').normalize('NFKC').replace(/[’‘]/g,"'").replace(/[–—]/g,'-').replace(/\s+/g,' ').trim();
  const prefix=title.split(/\s+[|\-]\s+/)[0];
  const meaningful=prefix.length>=8&&!/^(official|developer|new player|launch trailer|season|update|patch|gameplay|trailer)\b/i.test(prefix);
  return (meaningful?prefix:title).toLowerCase().replace(/[^a-z0-9]+/g,' ').trim();
 }
 function group(rows){
  const groups=[],buckets=new Map();
  for(const row of rows){const k=key(row);const prior=buckets.get(k);const span=prior?Math.abs(Date.parse(prior.publishedAt)-Date.parse(row.publishedAt)):Infinity;
   if(prior&&span<=7*86400000){prior.relatedUploads.push(row);}else{const item={...row,relatedUploads:[]};groups.push(item);buckets.set(k,item);}
  }return groups;
 }
 const api={key,group};if(typeof module!=='undefined'&&module.exports)module.exports=api;else scope.HBVideoHighlights=api;
})(typeof window==='undefined'?{}:window);